import { useEffect, useState } from "react";
import { useErrorStore } from "../store/errorStore";
import AppLoader from "./AppLoader";
import { useTranslation } from "react-i18next";
import { useWindowDimensions, View } from "react-native";
import { ROUTES } from "../shared/constants/routes";
import { CustomButton, ButtonVariant } from "./CustomButton";
import getGlobalStyles from "../globalStyles";
import { CommonActions, useNavigation } from "@react-navigation/native";
import { useNavStore } from "../store/navStore";

export default function ErrorScreen() {
    const { error, setError } = useErrorStore();
    const [redirectHome, setRedirectHome] = useState(false)
    const { t } = useTranslation();
    const gStyles = getGlobalStyles();
    const { height } = useWindowDimensions()
    const { getCurrentRoute } = useNavStore();
    const navigation = useNavigation<any>();
    useEffect(() => {
        console.log(getCurrentRoute());
        const currentRoute = getCurrentRoute();
        if (currentRoute?.name !== ROUTES.HOME || currentRoute?.params !== undefined) {
            // Error screen will be avoided instead redirected to home screenin case of error
            navigation.dispatch(
                CommonActions.reset({
                    index: 0,
                    routes: [{ name: ROUTES.HOME }],
                })
            );
        }
        return () => {
            setError(null);
            setRedirectHome(false)
        }
    }, []);

    useEffect(() => {
        if (redirectHome) {
            navigation.dispatch(
                CommonActions.reset({
                    index: 0,
                    routes: [{ name: ROUTES.HOME }],
                })
            );
        }
    }, [redirectHome]);
    if (error) {
        return (
            <View style={{ flex: 1, flexDirection: 'column' }}>
                <AppLoader
                    isLoading={false}
                    icon="news"
                    style={{ position: 'relative' }}
                    title={t("screens.error.title")}
                    description={t("screens.error.subtitle")}
                />
                <View style={[gStyles.centerRow, { gap: 16, marginBottom: height * 0.11 }]}>
                    <CustomButton icon="home" variant={ButtonVariant.NORMAL_PRIMARY} onPress={() => setRedirectHome(true)}>Home</CustomButton>
                </View>
            </View>

        );
    }

}
